// engagement events
import createEngagementEvent from '../../../events/create.event.engagement';

const openCreateEngagementHandler = () => () => {
  createEngagementEvent.publish();
};

export default openCreateEngagementHandler;
